<template>
  <div class="u_dialog_panel" @click.stop="noop">
    <div class="mask" v-if="visible" @click="handleClose"></div>
    <transition name="fade">
      <div v-if="visible" class="dialog_body">
        <div class="login_pop">
          <img @click="handleClose" class="close zpointer" src="@/assets/static/icon/jxr_login_close.png" alt="" />
          <div class="title1 fs30">账户登录</div>
          <div class="input_box flex-box">
            <img src="@/assets/static/icon/jxr_login_phone.png" class="icon1" />
            <input type="text" class="m-input fs20 flex-grow-1" name="mobile" placeholder="请输入账号" v-model="mobile" />
          </div>
          <div class="input_box flex-box">
            <img src="@/assets/static/icon/jxr_login_password.png" class="icon1" />
            <input id="password" :type="showPwd ? 'text' : 'password'" class="m-input fs20 flex-grow-1"
              placeholder="请输入密码" v-model="password" />
            <img @click="showPwd = !showPwd" v-if="showPwd" src="@/assets/static/icon/jxr_login_show.png" class="icon2" />
            <img @click="showPwd = !showPwd" v-else src="@/assets/static/icon/jxr_login_hide.png" class="icon2" />
          </div>
          <div class="part4 flex-box lh26">
            <div class="checkbox curosr">
              <input class="check_img" type="checkbox" name="keeplogin" :checked="rememberAccount" />
            </div>
            <div class="fs18 col3 flex-grow-1" @click="rememberAccount = !rememberAccount">记住账号</div>
            <router-link to="/RetrievePassword" class="fs18 col3 curosr" @click="handleClose">忘记密码？</router-link>
          </div>
          <div class="btn_login cursor" @click="login">登录</div>
          <router-link to="Enroll" @click="handleClose" class="fs18 col3 lh26 flex-box flex-center">
            没有账号？请<span class="blue curosr">立即注册</span>
          </router-link>
        </div>

        <div class="btn_box" v-if="confirmText || cancelText">
          <div class="cancel btn" :style="cancelStyle" v-if="cancelText" @click="handleCancel">
            {{ cancelText }}
          </div>
          <div class="confirm btn" :style="confirmStyle" v-if="confirmText" @click="handleConfirm">
            {{ confirmText }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: "UDialog",
  props: {
    visible: { type: Boolean, default: false, required: true },
    // 确定按钮的⽂案
    confirmText: { type: [String, Boolean], default: false },
    confirmStyle: { type: String, default: "" },
    // 取消按钮的⽂案
    cancelText: { type: [String, Boolean], default: false },
    cancelStyle: { type: String, default: "" },
  },
  created() {
    this.$nextTick(() => {
      document.body.insertBefore(this.$el, document.body.lastChild);
    });
    if (this.$cookies.get("account")) {
      this.mobile = this.$cookies.get("account");
    }
  },
  beforeUnmount() {
    document.body.removeChild(this.$el);
  },
  data() {
    return {
      rememberAccount: true,
      showPwd: false,
      mobile: "",
      password: "",
    };
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.$emit("close");
    },
    // 确定按钮
    handleConfirm() {
      this.$emit("confirm");
    },
    // 取消按钮
    handleCancel() {
      this.$emit("cancel");
    },
    noop() { },
    login() {
      let that = this;
      that.$api.Login({
        mobile: that.mobile,
        password: that.password,
      }).then((res) => {
        if (res.code == 1) {
          if (this.rememberAccount) {
            that.$cookies.set("account", that.mobile);
          }
          that.$cookies.set("token", res.data.userinfo.token);
          that.$message({
            customClass: 'custom-message',
            message: "登录成功",
            type: "success",
            duration: 3000,
          });
          that.getUserInfo();
        } else {
          that.$message({
            customClass: 'custom-message',
            message: res.msg,
            type: "error",
            duration: 3000,
          });
        }
      }).catch(err => {
        that.$message({
          customClass: 'custom-message',
          message: err.msg,
          type: "error",
          duration: 3000,
        });
      })
    },
    // 获取用户信息
    getUserInfo() {
      let that = this;
      that.$api.GetUserInfo().then(res => {
        if (res.code == 1) {
          this.$cookies.set('userinfo', res.data.group_model);
          this.$emit('loginSuc');
        }
      }).catch(err => {
        console.log(err)
      })
    },
  },
};
</script>
<style lang="less" scoped>
.u_dialog_panel {
  .mask {
    width: 100vw;
    height: 100vh;
    background: rgba(21, 21, 21, 0.3);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    // backdrop-filter: blur(5px);
  }

  .dialog_body {
    // background-color: #fff;
    position: fixed;
    left: 50vw;
    top: 50vh;
    z-index: 1001;
    transform: translate(-50%, -50%);
    transform-origin: 0 0;
    border-radius: 20px;

    &.open-enter {
      opacity: 0;
      transform: scale(0.7) translate(-50%, -50%);
      transition: all 0.3s;
    }

    &.open-enter-to {
      opacity: 1;
      transform: scale(1) translate(-50%, -50%);
      transition: all 0.3s;
    }

    .btn_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 80px 50px;

      .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 195px;
        height: 60px;
        border-radius: 10px;
        font-size: 18px;
        border-style: solid;
        border-width: 1px;

        &:hover {
          cursor: pointer;
        }

        &+.btn {
          border-left: 1px solid #ddd;
        }

        &.cancel {
          color: #aaa;
          border-color: #aaa;
        }

        &.confirm {
          background-color: var(--blue);
          color: #fff;
        }
      }
    }

    .login_pop {
      position: relative;
      padding: 75px 90px 40px;
      width: 566px;
      background: #ffffff;
      box-shadow: 0px 2px 34px 0px rgba(0, 0, 0, 0.2);
      border-radius: 24px;
      border: 6px solid rgba(255, 255, 255, 0.4);

      .title1 {
        margin: 0 0 55px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: #3d7efe;
        line-height: 42px;
        letter-spacing: 1px;
        text-shadow: 0px 2px 34px rgba(0, 0, 0, 0.2);
        text-align: center;
        font-style: normal;
      }

      .input_box {
        padding: 0 16px;
        height: 60px;
        border-radius: 8px;
        border: 1px solid #3d7efe;

        .icon1 {
          margin-right: 12px;
          display: block;
          width: 28px;
          height: 28px;
        }

        .icon2 {
          display: block;
          width: 24px;
          height: 24px;
        }

        .m-input {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #040404;
          line-height: 28px;
          letter-spacing: 1px;
          text-align: left;
          background: #fff;
        }
      }

      .input_box+.input_box {
        margin-top: 28px;
      }

      .part4 {
        margin: 15px auto 44px;
      }

      .btn_login {
        border: none;
        margin: 0 auto 36px;
        font-size: 20px;
        color: #fff;
        font-weight: 500;
        text-align: center;
        width: 386px;
        height: 60px;
        line-height: 60px;
        border-radius: 8px;
        background: #3d7efe;
      }

      .check_img {
        width: 14px;
        height: 14px;
        margin-right: 6px;
        background: rgba(240, 84, 77, 1);
        margin-top: 0;
      }

      input[type="checkbox"] {
        width: 14px;
        height: 14px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        line-height: 15px;
        position: relative;
      }

      input[type="checkbox"]::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        background: #fff;
        width: 100%;
        height: 100%;
        border: 1px solid #c5cdd6;
      }

      input[type="checkbox"]:checked::before {
        content: "\2713";
        background-color: #3d7efe;
        position: absolute;
        bottom: 4px;
        left: 0px;
        width: 100%;
        border: 1px solid #3d7efe;
        color: #fff;
        font-size: 10px;
        font-weight: bold;
      }

      .blue {
        color: #3d7efe;
      }

      .close {
        position: absolute;
        top: 20px;
        right: 20px;
        display: block;
        width: 26px;
        height: 26px;
        object-fit: contain;
      }
    }
  }
}
</style>
